export type EstadoSync = 'ocioso' | 'sincronizando' | 'erro' | 'offline'

export interface InfoSync {
  estado: EstadoSync
  ultimaSync: string | null
  erro: string | null
}

let info: InfoSync = { estado: 'ocioso', ultimaSync: null, erro: null }
const ouvintes = new Set<() => void>()

export function obterInfoSync(): InfoSync {
  return info
}

export function definirInfoSync(parcial: Partial<InfoSync>): void {
  info = { ...info, ...parcial }
  ouvintes.forEach((ouvinte) => ouvinte())
}

export function assinarSync(ouvinte: () => void): () => void {
  ouvintes.add(ouvinte)
  return () => ouvintes.delete(ouvinte)
}
